export default "__VITE_ASSET__BlvCODxq__"